<template>
    <section class="product-view-page">
        <div class="single_product mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <div class="panel panel-info">
                            <div class="panel-body list-group-item">
                                <div class="item-block"
                                    v-if="items.length > 0">
                                    <div class="cart-item" 
                                        v-for="item in items">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <img class="img-responsive" 
                                                    :src="appUrl+'/'+item.image" 
                                                    :alt="item.name" 
                                                    width="80px">
                                            </div>
                                            <div class="col-md-5 my-auto">
                                                <a :href="appUrl+'/products/'+item.id"
                                                    class="primary-link">
                                                    <h5 class="product-name">
                                                        <strong>{{ item.name }}</strong>
                                                    </h5>
                                                </a>
                                                <h5>
                                                    <small>SKU: {{ item.sku }}</small>
                                                </h5>
                                            </div>
                                            <div class="col-md-5 my-auto">
                                                <div class="row">
                                                    <div class="col-md-4 text-left my-auto">
                                                        <h6 class="mb-0">
                                                            <strong>
                                                                <i class="fas fa-rupee-sign mr-1"></i>
                                                                {{ item.price }}
                                                                <span class="text-muted">x</span>
                                                            </strong>
                                                        </h6>
                                                    </div>
                                                    <div class="col-md-6 my-auto">
                                                        <b-form-spinbutton id="product-quantity"
                                                            class="text-center"
                                                            v-model="item.quantity"
                                                            min="0"
                                                            :max="item.min_quantity * 10"
                                                            :step="item.min_quantity"
                                                            @change="updateCart(item.unique_id, $event)"
                                                            inline></b-form-spinbutton>
                                                    </div>
                                                    <div class="col-md-2 my-auto">
                                                        <a href="javascript:void(0)" 
                                                            class="text-danger"
                                                            @click="removeItem(item.unique_id)">
                                                            <i class="far fa-trash-alt"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                                <div class="item-block" v-else>
                                    <div class="cart-item">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <p class="mb-0">Your shopping cart is empty.</p>    
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                                <div class="row text-center">
                                    <div class="col-md-12 text-right">
                                        <h4 class="mb-0">
                                            Total 
                                            <strong>
                                                <i class="fas fa-rupee-sign mr-1"></i>
                                                {{ total }}
                                            </strong>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <ul class="list-group mb-3">
                            <li class="list-group-item d-flex justify-content-between lh-condensed">
                                <div>
                                    <h6 class="my-0">Subtotal</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ subtotal }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="tax > 0">
                                <div>
                                    <h6 class="my-0">Tax</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ tax }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="discount > 0">
                                <div>
                                    <h6 class="my-0">Discount</h6>
                                    <small class="text-muted">Referral Points</small>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ discount }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between lh-condensed"
                                v-if="deliveryCharge > 0">
                                <div>
                                    <h6 class="my-0">Delivery Charges</h6>
                                </div>
                                <span class="text-muted">
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ deliveryCharge }}
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between">
                                <div>
                                    <h6 class="my-0">Total</h6>
                                </div>
                                <strong>
                                    <i class="fas fa-rupee-sign mr-1"></i>
                                    {{ total }}
                                </strong>
                            </li>
                        </ul>
                        <div class="alert alert-info"
                            v-if="freeDeliveryMessage"
                            v-html="freeDeliveryMessage">
                        </div>
                        <a :href="appUrl+'/checkout'" 
                            class="update-cart w-100 text-center"
                            v-if="items.length > 0">
                            Proceed to checkout
                        </a>
                        <a :href="appUrl" 
                            class="shopping-cart-black w-100 text-center mt-2">
                            Continue shopping
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="cart" />
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                items: [],
                subtotal: 0,
                discount: 0,
                tax: 0,
                total: 0,
                deliveryCharge: 0,
                freeDeliveryMessage: null,
            };
        },
        mounted() {
            this.getCartItems();
        },
        methods: {
            getCartItems() {
                var that = this;
                axios.get('api/get-cart-items')
                .then(function(response) {
                    that.items = response.data.items;
                    that.subtotal = response.data.subtotal;
                    that.tax = response.data.tax;
                    that.discount = response.data.discount;
                    that.total = response.data.total;
                    that.deliveryCharge = response.data.delivery_charge;
                    that.freeDeliveryMessage = response.data.free_delivery_message;
                    if (response.data.cart_updated == true) {
                        that.$notify({
                            group: 'cart',
                            title: 'Cart Updated',
                            type: 'success',
                            text: 'Some of your cart items got updated',
                        });
                    }
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            clearCart() {
                var that = this;
                axios.get('api/clear-cart')
                .then(function(response) {
                    that.getCartItems();
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            removeItem(uniqueId) {
                var that = this;
                axios.post('api/remove-cart-item', {
                    unique_id: uniqueId,
                })
                .then(function(response) {
                    that.getCartItems();
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            updateCart(itemId, quantity) {
                var that = this;
                axios.post('api/update-cart', {
                    item_id: itemId,
                    quantity: quantity,
                })
                .then(function(response) {
                    that.getCartItems();
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            }
        }
    };
</script>
